var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-notification',{attrs:{"type":"is-danger","active":_vm.alert},on:{"update:active":function($event){_vm.alert=$event}}},[_vm._v("\n  "+_vm._s(_vm.error)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }